import React, { Component } from "react";
import cx from "classnames";
//
import ScreenHead from "./ScreenHead";
import ScreenFoot from "./ScreenFoot";

class Screen extends Component {
  componentDidUpdate() {
    const { scrollToTop } = this.props;

    if (scrollToTop) {
      this.screenBody.scrollTop = 0;
    }
  }

  render() {
    const {
      children,
      title,
      breadcrumbs,
      className,
      prevLabel,
      isActive,
      noFooter,
      onBack,
      onClose,
      nextLabel,
      onNext,
      nextDisabled,
      large,
      full,
      scrollRef,
      editSearch,
      step
    } = this.props;

    let bodyRef = el => {
      this.screenBody = el;
    };

    if (scrollRef) {
      bodyRef = scrollRef;
    }

    return (
      <div
        className={cx(
          "screen",
          "u-clearfix",
          {
            "screen--active": isActive,
            "screen--large": large === true,
            "screen--full": full === true
          },
          className
        )}
      >
        <div ref={bodyRef} className="screen__body">
          <ScreenHead
            {...{
              breadcrumbs,
              onBack,
              onClose,
              onClick: editSearch,
              step,
              title
            }}
          />
          <div className="screen__container">{children}</div>
        </div>
        {!noFooter && (
          <ScreenFoot
            prevLabel={prevLabel}
            nextLabel={nextLabel}
            onNext={onNext}
            nextDisabled={nextDisabled}
            onBack={onBack}
          />
        )}
      </div>
    );
  }
}
export default Screen;
